import { z } from "zod";

export const ReviewExchangeRateSchema = z.object({
  original: z.number().nullable(),
  current: z.number(),
  modified: z.boolean(),
});

export type ReviewExchangeRate = z.infer<typeof ReviewExchangeRateSchema>;

export const ReviewExchangeRatesSchema = z.record(z.string(), ReviewExchangeRateSchema);
export type ReviewExchangeRates = z.infer<typeof ReviewExchangeRatesSchema>;

export enum BudgetMode {
  MANUAL_INPUT = "MANUAL_INPUT",
  SUM_OF_SUGGESTED = "SUM_OF_SUGGESTED",
  PERCENT = "PERCENT",
  DISABLED = "DISABLED",
  SUM_OF_CUSTOM = "SUM_OF_CUSTOM",
}

export const BudgetConfigSchema = z.object({
  mode: z.nativeEnum(BudgetMode),
  percent: z.number().optional().nullable(),
  fieldId: z.string().optional().nullable(),
});

export type BudgetConfig = z.infer<typeof BudgetConfigSchema>;

const roundingDirectionSchema = z.enum(["up", "down", "nearest"]);

const CurrencyRoundingRule = z.object({
  position: z.string().nullable(),
  direction: roundingDirectionSchema,
});

const CurrencyRoundingRules = z
  .record(z.string(), z.record(z.string(), CurrencyRoundingRule))
  .optional();

export const CycleRoundingRulesSchema = z.object({
  salary: CurrencyRoundingRules,
  equity: CurrencyRoundingRules,
  bonusAward: CurrencyRoundingRules,
  variableTarget: CurrencyRoundingRules,
});

export interface PromotionQuestionConfig {
  questions: Array<{
    id: string;
    question: string;
  }>;
}

export interface SalaryJustificationConfig {
  allowedVariancePercent?: number;
  // Future extensibility:
  // customMessage?: string;
  // requireManagerApproval?: boolean;
  // varianceByLevel?: Record<string, number>;
  // questions?: Array<{ id: string; question: string }>;
}

export const ShowOnSchema = z.enum(["salary", "equity", "bonus", "summary", "overview"]);

export type ShowOnOption = z.infer<typeof ShowOnSchema>;

const SingleCustomComponentConfigSchema = z.object({
  label: z.string(),
  budget: z.object({
    type: z.enum(["NUMBER", "DOLLAR"]).optional(),
    numeratorFieldId: z.string(),
    denominatorFieldId: z.string().optional().nullable(),
    showOn: z.array(ShowOnSchema).default([]),
  }),
});

export const CustomComponentConfigSchema = z.record(z.string(), SingleCustomComponentConfigSchema);
export type CustomComponentConfig = z.infer<typeof CustomComponentConfigSchema>;
